import { authService } from '../services'
import { router } from '../router'
import Vue from 'vue'

const user = JSON.parse(localStorage.getItem('user'))
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: { initials: null } }

const actions = {
  login ({ dispatch, commit }, { initials, password }) {
    commit('loginRequest', { initials })

    return authService.login(initials, password)
      .then(
        user => {
          commit('loginSuccess', user)
          router.push('/home/project-owner')
          return user.result
        },
        error => {
          commit('loginFailure', error)
          return Promise.reject(error)
        }
      )
  },
  logout ({ commit }) {
    authService.logout()
    commit('logout')
  },
  generateToken ({ commit, dispatch }, { email }) {
    commit('generateTokenRequest', { email })

    return authService.generateToken(email)
      .then(user => {
        commit('generateTokenSuccess')
        return user.result
      }).catch(error => {
        commit('resetPasswordSuccess')
        return Promise.reject(error)
      })
  },
  resetPassword ({commit, dispatch}, { token, password }) {
    commit('resetPasswordRequest', { token, password })

    return authService.resetPassword(token, password)
      .then(user => {
        return user.result
      }).catch(error => {
        console.error(error)
        return Promise.reject(error)
      })
  }
}

const mutations = {
  loginRequest (state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess (state, user) {
    state.status = { loggedIn: true }
    state.user = user
  },
  loginFailure (state) {
    state.status = {}
    state.user = null
  },
  logout (state) {
    state.status = {}
    state.user = null
  },
  generateTokenRequest (state, user) {
    state.user = user
  },
  generateTokenSuccess (state, user) {
    Vue.prototype.$toast('En återställningslänk har skickats till din email', 'info')
  },
  resetPasswordRequest (state, user) {
    state.user = user
  },
  resetPasswordSuccess (state, user) {
    Vue.prototype.$toast('Lösenordet är återställt', 'success')
  }
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/auth.module.js